import none from '../../img/leoLogo.png'

export const ghelian=[
    {
      "id": "181",
      "title": "دوسیب",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "182",
      "title": "تمشک بستنی",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "183",
      "title": "شامپاین",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "184",
      "title": "سمبا",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "185",
      "title": "لیدی کیلر",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "186",
      "title": "شب‌های مسکو",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "187",
      "title": "بلوبری",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "188",
      "title": "لیمو نعلناع",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "189",
      "title": "لاو",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1810",
      "title": "آدامس دارچین",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1811",
      "title": "شلیل",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1812",
      "title": "هندوانه یخ",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1813",
      "title": "الو یخ",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1814",
      "title": "سیب یخ",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1815",
      "title": "فانتوم",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1816",
      "title": "پینک لیدی",
      "desciption": "",
      "price": "295",
      "image": none
    },
    {
      "id": "1817",
      "title": "سینی ویژه",
      "desciption": "پاستیل، لواشک لقمه ای، مارشمالو، تخمه، نبات",
      "price": "270",
      "image": none
    },
  ]